var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(!_vm.doctors)?_c('div',{staticClass:"spinner-border",attrs:{"id":"main-spinner","role":"status"}}):_c('horaires-wrapper',{attrs:{"doctors":_vm.doctors}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }